import type {
  DropdownMenu,
  HeaderButton,
  MegaMenuColumn,
  MenuLink,
} from '~/types/navigation.ts';

export const categoriesMenu: MegaMenuColumn[] = [
  {
    heading: 'Particulier',
    links: [
      {
        label: 'Aankoopmakelaar',
        href: '/aankoopmakelaar',
      },
      {
        label: 'Bankmedewerker',
        href: '/bankzaken',
      },
      {
        label: 'Belastingadviseur',
        href: '/belasting',
      },
      {
        label: 'Duurzaam wonen adviseur',
        href: '/duurzaamwonen',
      },
      {
        label: 'Financieel planner',
        href: '/financieleplanning',
      },
      {
        label: 'Hypotheekadviseur',
        href: '/hypotheek',
      },
      {
        label: 'Kredietadviseur',
        href: '/lenen',
      },
      {
        label: 'Notaris',
        href: '/notariaat',
      },
      {
        label: 'Pensioenadviseur',
        href: '/pensioen',
      },
      {
        label: 'Scheidingsadviseur',
        href: '/scheiding',
      },
      {
        label: 'Taxateur',
        href: '/taxatie',
      },
      {
        label: 'Verkoopmakelaar',
        href: '/verkoopmakelaar',
      },
      {
        label: 'Vermogensadviseur',
        href: '/vermogen',
      },
      {
        label: 'Verzekeringsadviseur',
        href: '/verzekering',
      },
    ],
  },
  {
    heading: 'Zakelijk',
    links: [
      {
        label: 'Aansprakelijkheidsverzekeringen',
        href: '/aansprakelijkheidsverzekering',
      },
      {
        label: 'Arbeidsongeschiktheidsverzekeringen',
        href: '/arbeidsongeschiktheidsverzekering',
      },
      {
        label: 'Bedrijfsschadeverzekeringen',
        href: '/bedrijfsschadeverzekering',
      },
      {
        label: 'Betalingsrisicoverzekeringen',
        href: '/betalingsrisicoverzekering',
      },
      {
        label: 'Pensioenregelingen',
        href: '/pensioenregeling',
      },
      {
        label: 'Rechtsbijstandverzekeringen',
        href: '/rechtsbijstandverzekering',
      },
      {
        label: 'Verzuimverzekeringen',
        href: '/verzuimverzekering',
      },
      {
        label: 'Zakelijke financieringen',
        href: '/zakelijke-financiering',
      },
    ],
  },
];

export const aboutMenu: DropdownMenu = [
  {
    label: 'Kennisbank',
    href: '/kennisbank',
  },
  {
    label: 'Expertplatform',
    href: '/expert',
  },
  {
    label: 'Blogs',
    href: '/blogs',
  },
  {
    label: 'Over ons',
    href: '/home/overons',
  },
];

export const headerMenu: MenuLink[] = [
  {
    slug: 'categories',
    label: 'Dienstverleners',
    subMenu: categoriesMenu,
    subMenuType: 'mega',
  },
  {
    slug: 'about',
    label: 'Kennis & informatie',
    subMenu: aboutMenu,
    subMenuType: 'dropdown',
  },
];

export const headerButtons: HeaderButton[] = [
  {
    label: 'Voor bedrijven',
    href: 'https://extranet.advieskeuze.nl',
    variant: 'blue',
    target: '_blank',
  },
];
